import React, { useCallback } from 'react';
import TryItOutWarningDialog from '@modules/openCloud/swagger/components/TryItOutWarningDialog';
import { logTryItOutEvent } from '@modules/openCloud/swagger/components/tryItOut';
import DocsSiteEventType from '@modules/eventStream/enum/DocsSiteEventType';
import useTryItOut from '../../hooks/useTryItOut';
import useOperation from '../../hooks/useOperation';

export interface TryItOutWarningDialogComponentProps {
  warningOpen: boolean;
  setWarningOpen: (open: boolean) => void;
  onContinue: () => void;
}

const TryItOutWarningDialogComponent: React.FC<TryItOutWarningDialogComponentProps> = ({
  warningOpen,
  setWarningOpen,
  onContinue,
}) => {
  const { authMode, setWarningAccepted } = useTryItOut();
  const { method, url, riskLevel } = useOperation();

  const handleClose = useCallback(() => {
    logTryItOutEvent(DocsSiteEventType.TryItOutClickCancelWarning, {
      method: method.toUpperCase(),
      url,
      riskLevel,
      authMode,
    });
    setWarningOpen(false);
  }, [method, url, riskLevel, authMode, setWarningOpen]);

  const handleContinue = useCallback(() => {
    logTryItOutEvent(DocsSiteEventType.TryItOutClickAcceptWarning, {
      method: method.toUpperCase(),
      url,
      riskLevel,
      authMode,
    });
    setWarningAccepted(true);
    setWarningOpen(false);
    onContinue();
  }, [method, url, riskLevel, authMode, setWarningAccepted, setWarningOpen, onContinue]);

  return (
    <TryItOutWarningDialog open={warningOpen} onClose={handleClose} onContinue={handleContinue} />
  );
};

export default TryItOutWarningDialogComponent;
